module.exports = __webpack_public_path__ + "static/buck-eff7b6addbbea820385544fde675693f.png";